import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import Helmet from 'react-helmet';
import { Link, browserHistory } from 'react-router';
import { getProducts } from 'redux/modules/products';
import { createNewPartnerClient } from 'redux/modules/newClient';
import { getAllClients, getPartnerDetailsByPartnerOrgId, setOrderColumn, setSearchQuery, getTeamMembers, setUserTableFilter } from 'redux/modules/teamManagement';
import { getHasCommissionsAccount } from 'redux/modules/billing';
import { LeftNavLayout, PartnerAdjustmentForm } from 'containers';
import { DataTable, PageHeader, SocialNetworkIcon, SocialNetworkIconBar, Spinner } from 'components';
import { Table, TableHeader, TableHeaderCell, TableRow, TableRowCell } from 'components/Table';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';
import { ClientsFilterPanel } from 'components/Admin';
import { NewAffiliateWrap } from 'containers/Admin';
import { NewLocationWrap } from 'containers/Admin';
import { NewClientWrap } from 'containers/Admin';
import * as styles from './Clients.scss';
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import pluralize from 'pluralize';

var _ = require('lodash');

var Clients = (_dec = connect(function (state) {
  return {
    affiliateProducts: state.products.productsByOrgId,
    gettingAffiliateProducts: state.products.gettingProducts,
    organization: state.organization.current,
    allClients: state.teamManagement.allClients,
    isLoadingClients: state.teamManagement.isLoadingClients,
    theme: state.theme,
    sortColumnName: state.teamManagement.sortColumnName,
    sortColumnDirection: state.teamManagement.sortColumnDirection,
    searchQuery: state.teamManagement.searchQuery,
    teamMembers: state.teamManagement.teamMembers,
    filterUserId: state.teamManagement.filterUserId,
    user: state.auth.user,
    selectedFields: state.teamManagement.selectedClientTableColumns,
    allColumns: state.teamManagement.clientTableColumns,
    partnerDetails: state.teamManagement.partnerDetails,
    newClientFormValues: state.newClient,
    clientType: state.teamManagement.clientType,
    partnerSubtype: function () {
      try {
        return state.whiteLabel.Organization.OrganizationSubtype.subtype;
      } catch (e) {
        return null;
      }
    }()
  };
}, {
  createNewPartnerClient: createNewPartnerClient,
  getAllClients: getAllClients,
  getHasCommissionsAccount: getHasCommissionsAccount,
  getProducts: getProducts,
  setOrderColumn: setOrderColumn,
  setSearchQuery: setSearchQuery,
  getTeamMembers: getTeamMembers,
  setUserTableFilter: setUserTableFilter,
  getPartnerDetailsByPartnerOrgId: getPartnerDetailsByPartnerOrgId
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(Clients, _Component);

  var _super = _createSuper(Clients);

  function Clients(props) {
    var _this;

    _classCallCheck(this, Clients);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "isHovered", function (index) {
      return _this.state.hovered === index;
    });

    _defineProperty(_assertThisInitialized(_this), "reloadTable", function (fields) {
      var selectedClientType = _this.state.clientTypeOptions.find(function (o) {
        return o.selected;
      });

      _this.props.getAllClients({
        search: _this.state.clientSearch,
        orgState: selectedClientType.key === 'current' ? 'active' : selectedClientType.key,
        orgTypeId: "".concat(_this.props.theme.org) === '0' ? 3 : null,
        parentOrganizationId: _this.props.theme.org
      });
    });

    _defineProperty(_assertThisInitialized(_this), "searchDidChange", function (query) {
      setTimeout(function () {
        return _this.reloadTable();
      }, 100);
    });

    _defineProperty(_assertThisInitialized(_this), "handleRowHover", function (selectedRows) {
      _this.setState({
        hovered: selectedRows
      });

      console.log('hover over');
      console.log(selectedRows);
    });

    _defineProperty(_assertThisInitialized(_this), "handleRowSelection", function (selectedRows) {
      _this.searchDidChange('');

      _this.setState({
        clientSearch: ''
      });

      browserHistory.push({
        pathname: "/global/clients/".concat(selectedRows.id)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSearchValueChanged", _.debounce(_this.searchDidChange, 500));

    _defineProperty(_assertThisInitialized(_this), "handleUserFilterDropdownChange", function (e, idx, value) {
      _this.props.setUserTableFilter(value);

      setTimeout(function () {
        return _this.reloadTable();
      }, 100);
    });

    var isMLP = props.partnerSubtype && props.partnerSubtype === 'multilocation';
    _this.state = {
      hovered: 3,
      showAddClientDialog: false,
      showNewAffiliateDialog: false,
      clientTypeOptions: [{
        title: 'Current',
        key: 'current',
        selected: true
      }, {
        title: 'Pending',
        key: 'pending',
        selected: false
      }, {
        title: 'Cancelled',
        key: 'cancelled',
        selected: false
      }],
      headerFields: [{
        key: 'Contracts[0].id',
        name: 'Contract ID',
        selected: false
      }, {
        key: 'name',
        name: 'Business Name',
        selected: true
      }, {
        key: ['Contracts[0].Owner.firstName', 'Contracts[0].Owner.lastName'],
        name: 'Owner Name',
        selected: true
      }, {
        key: 'Type.name',
        name: isMLP ? 'Location Type' : 'Client Type',
        selected: true
      }, {
        key: 'SocialAccounts',
        name: 'Social Networks',
        renderAs: function renderAs(_ref) {
          var SocialAccounts = _ref.SocialAccounts;
          var networks = SocialAccounts ? SocialAccounts.map(function (sa) {
            return "".concat("".concat(sa.platform).split(' ')[0]).toLowerCase();
          }) : null;
          return networks ? /*#__PURE__*/React.createElement(SocialNetworkIconBar, {
            networks: new Set(networks)
          }) : null;
        },
        selected: true
      }, {
        key: 'Contracts[0].email',
        name: 'Email',
        selected: true
      }, {
        key: 'Contracts[0].phone',
        name: 'Phone',
        transform: function transform(str) {
          return "".concat(str).replace(/\D+/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        },
        selected: false
      }, {
        key: ['Contracts[0].Address.locality', 'Contracts[0].Address.region', 'Contracts[0].Address.country'],
        name: 'Address',
        selected: false
      }, {
        key: 'Contracts[0].Products[0].title',
        transform: function transform(str) {
          return _.startCase(str);
        },
        name: 'Package Name',
        selected: false
      }, {
        key: 'Contracts[0].Products[0].retailMonthlyPrice',
        transform: function transform(str) {
          var d = parseFloat(str) / 100.0;
          return d.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD'
          });
        },
        name: 'Package Monthly Fee',
        selected: false
      }, {
        key: 'Contracts[0].Products[0].adsBudget',
        transform: function transform(str) {
          var d = parseFloat(str) / 100.0;
          return d.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD'
          });
        },
        name: 'Package Ads Fee',
        selected: false
      }, {
        key: 'createdAt',
        name: 'Client Created Date',
        transform: function transform(str) {
          return moment(str).format('ll');
        },
        selected: false
      }, {
        key: 'status',
        name: 'Status',
        transform: function transform(str) {
          return _.upperFirst(str);
        },
        selected: true
      }, {
        key: 'paidToDate',
        name: 'Paid Through',
        defaultValue: '',
        transform: function transform(str) {
          return moment(str).format('ll');
        },
        selected: true
      }, props.user && props.user.isLikeableLocal && {
        key: 'BillingAccounts[0].PaymentMethod.name',
        name: 'Payment Gateway',
        transform: function transform(str) {
          return _.startCase(str);
        },
        selected: false
      }, {
        key: 'Queues',
        name: 'Queues',
        defaultValue: '',
        selected: false,
        renderAs: function renderAs(_ref2) {
          var Queues = _ref2.Queues;
          var counts = {
            q: 0,
            cat: 0
          };
          Queues.forEach(function (q) {
            counts.q += 1;
            counts.cat += q.Categories.length;
          });

          if (counts.q > 0 && counts.cat > 0) {
            return "".concat(counts.q, " ").concat(pluralize('Queue', counts.q), " subscribed to ").concat(counts.cat, " ").concat(pluralize('Category', counts.cat));
          }

          return '';
        }
      }, props.user && props.user.isLikeableLocal && {
        key: ['Contracts[0].SalesUser.firstName', 'Contracts[0].SalesUser.lastName'],
        name: 'Sales Rep',
        selected: false
      }, props.user && props.user.isLikeableLocal && {
        key: 'ParentOrganization.name',
        name: 'Partner Name',
        defaultValue: '',
        selected: false
      }, {
        key: 'FacebookAd',
        name: 'Facebook Ad Account',
        defaultValue: '',
        renderAs: function renderAs(_ref3) {
          var SocialAccounts = _ref3.SocialAccounts;
          var ad = SocialAccounts ? SocialAccounts.find(function (sa) {
            return sa.FacebookAdAccount && sa.FacebookAdAccount.adAccountId;
          }) : null;
          return ad ? 'Connected' : 'None';
        },
        selected: true
      }].filter(function (f) {
        return f;
      })
    };
    return _this;
  }

  _createClass(Clients, [{
    key: "componentDidMount",
    value:
    /** *******************************************************************************************
    LIFECYCLE METHODS
    ********************************************************************************************/
    function componentDidMount() {
      var _this2 = this;

      this.reloadTable();
      this.props.getTeamMembers();
      this.props.getPartnerDetailsByPartnerOrgId(this.props.theme.org).then(function (res) {
        var partnerType = res.data.terms.partnerType || null;

        if (partnerType !== 'affiliate' && partnerType !== 'multilocation') {
          _this2.props.getHasCommissionsAccount(_this2.props.theme.org);
        }

        if (partnerType === 'affiliate') {
          _this2.props.getProducts(_this2.props.theme.org);
        }
      });
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.allClients.length !== this.props.allClients.length) {
        this.reloadTable();
      }
    }
    /** *******************************************************************************************
    METHODS
    ********************************************************************************************/

  }, {
    key: "render",
    value:
    /** *******************************************************************************************
     RENDER METHODS
    ********************************************************************************************/
    function render() {
      var _this3 = this;

      var contractInfo = this.props.partnerDetails;
      var isMLP = this.props.partnerSubtype && this.props.partnerSubtype === 'multilocation';
      var flatAllColumns = [].concat.apply([], this.props.allColumns);
      var filteredClients = this.props.allClients.filter(function (c) {
        var pastGracePeriod = parseInt(c.gracePeriodState) >= 2;

        if (_this3.props.clientType === 'cancelled' && pastGracePeriod) {
          return c;
        } else if (_this3.props.clientType === 'current' && !pastGracePeriod) {
          return c;
        }
      });
      var teamMemberDropdown = null;

      if (this.props.teamMembers && this.props.teamMembers.length) {
        teamMemberDropdown = /*#__PURE__*/React.createElement("div", {
          style: {
            display: 'flex'
          }
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.dropdownLabel
        }, "Show Clients:"), /*#__PURE__*/React.createElement(DropDownMenu, {
          onChange: this.handleUserFilterDropdownChange,
          value: typeof this.props.filterUserId !== 'undefined' ? this.props.filterUserId : this.props.user.id,
          style: {
            height: 40,
            top: -8
          },
          underlineStyle: {
            border: 0
          }
        }, /*#__PURE__*/React.createElement(MenuItem, {
          value: this.props.user.id,
          primaryText: "Mine"
        }), /*#__PURE__*/React.createElement(MenuItem, {
          value: "all",
          primaryText: "All"
        }), this.props.teamMembers.map(function (u) {
          return u && u.id !== _this3.props.user.id ? /*#__PURE__*/React.createElement(MenuItem, {
            key: u.id,
            value: u.id,
            primaryText: "".concat(u.firstName, " ").concat(u.lastName)
          }) : null;
        })));
      }

      var modalWrap = null;

      if (this.props.partnerSubtype === 'multilocation') {
        modalWrap = /*#__PURE__*/React.createElement(NewLocationWrap, {
          contractInfo: contractInfo
        });
      } else if (this.props.partnerSubtype === 'affiliate') {
        modalWrap = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RaisedButton, {
          disabled: this.props.gettingAffiliateProducts || !this.props.affiliateProducts[this.props.theme.org],
          secondary: true,
          label: "Add Client",
          style: {
            marginRight: 32
          },
          onClick: function onClick() {
            _this3.setState({
              showNewAffiliateDialog: true
            });
          }
        }), /*#__PURE__*/React.createElement(NewAffiliateWrap, {
          contractInfo: contractInfo,
          open: this.state.showNewAffiliateDialog,
          onClose: function onClose() {
            _this3.setState({
              showNewAffiliateDialog: false
            });
          }
        }));
      } else {
        modalWrap = /*#__PURE__*/React.createElement(NewClientWrap, {
          contractInfo: contractInfo,
          partnerDetails: this.props.partnerDetails
        });
      }

      return /*#__PURE__*/React.createElement(LeftNavLayout, {
        sidebar: "admin",
        wrapStyle: {
          flex: '1 1 auto',
          padding: 36,
          overflow: 'auto'
        },
        appLayoutInnerStyle: {
          display: 'flex',
          flex: '1 1 auto',
          padding: 0,
          overflow: 'hidden',
          height: '100%'
        },
        rightPanel: /*#__PURE__*/React.createElement(ClientsFilterPanel, {
          columns: this.state.headerFields,
          isMLP: isMLP,
          reloadTable: this.reloadTable,
          clientTypeOptions: this.state.clientTypeOptions,
          handleClientTypeChange: function handleClientTypeChange(_ref4) {
            var key = _ref4.key;

            var opts = _toConsumableArray(_this3.state.clientTypeOptions);

            opts.forEach(function (o) {
              return o.selected = false;
            });
            var idx = opts.findIndex(function (o) {
              return o.key === key;
            });

            _.set(opts, "[".concat(idx, "].selected"), true);

            _this3.setState({
              clientTypeOptions: opts
            }, function () {
              return _this3.reloadTable();
            });
          },
          onChange: function onChange(key, isChecked) {
            var fields = _toConsumableArray(_this3.state.headerFields);

            var idx = fields.findIndex(function (_ref5) {
              var k = _ref5.key;
              return k === key;
            });

            _.set(fields, "[".concat(idx, "].selected"), isChecked);

            _this3.setState({
              headerFields: fields
            });
          }
        })
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "".concat(isMLP ? 'Location' : 'Client', " Management")
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'space-between'
        }
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: "".concat(isMLP ? 'Location' : 'Client', " Management")
      }), modalWrap), /*#__PURE__*/React.createElement("div", {
        className: styles.searchBar
      }, /*#__PURE__*/React.createElement(TextField, {
        placeholder: "Search Clients",
        value: this.state.clientSearch,
        name: "clientSearchField",
        onChange: function onChange(e) {
          return _this3.setState({
            clientSearch: e.target.value
          });
        },
        onKeyPress: function onKeyPress(e) {
          if (e.key === 'Enter') {
            _this3.searchDidChange(_this3.state.clientSearch);
          }
        }
      }), /*#__PURE__*/React.createElement(RaisedButton, {
        label: "Search",
        onClick: function onClick() {
          return _this3.searchDidChange(_this3.state.clientSearch);
        },
        style: {
          marginLeft: 24
        }
      }), this.state.clientSearch && this.state.clientSearch.length > 0 && /*#__PURE__*/React.createElement(RaisedButton, {
        label: "Clear",
        onClick: function onClick() {
          _this3.searchDidChange('');

          _this3.setState({
            clientSearch: ''
          });
        },
        style: {
          marginLeft: 24
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.searchBarCount
      }, "Number of ", isMLP ? 'locations' : 'clients', ":", ' ', filteredClients.length)), !this.props.allClients.length && this.props.isLoadingClients ? /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          height: 150
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DataTable, {
        firstColColored: true,
        headerFields: _toConsumableArray(this.state.headerFields).filter(function (f) {
          return f.selected;
        }).map(function (f) {
          return _objectSpread(_objectSpread({}, f), {}, {
            disableSort: true
          });
        }),
        data: this.props.allClients ? _toConsumableArray(this.props.allClients).map(function (client) {
          return _objectSpread({}, client);
        }) : [],
        searchValueChanged: this.handleSearchValueChanged,
        fixedHeader: true,
        height: 500,
        isLoading: this.props.isLoadingClients,
        onRowSelection: this.handleRowSelection,
        displayLoading: true
      })));
    }
  }]);

  return Clients;
}(Component), _defineProperty(_class2, "defaultProps", {}), _temp)) || _class);
export default Clients;